import React, { Component } from 'react';

import InputMask from 'react-input-mask';
import axios from 'axios';
import { FiAlertCircle } from 'react-icons/fi';
import {
	FaBuilding,
	FaCity,
	FaHome,
	FaRoad,
	FaMapMarkerAlt,
	FaThumbsUp
} from 'react-icons/fa';
import FormField from '../../style/styledComponents/FormField';
import TitleSubscriber from '../../style/styledComponents/TitleSubscriber';

import * as yup from 'yup';
import { Field, Form, Formik, useField } from 'formik';

class FormAddress extends Component {
	constructor() {
		super();

		this.state = {
			inputData: {
				cep: '',
				address: '',
				district: '',
				number: '',
				complement: '',
				state: '',
				city: ''
			}
		};

		this.initialValues = this.state.inputData;
		this.setField = this.setField.bind(this);
	}
	componentWillMount() {
		const getSession = window.sessionStorage.data_person;
	    const _addressPerson = getSession ? JSON.parse(getSession) : '';
		
		if (this.props.initialData) {
			let inputData = { ...this.state.inputData };
			let initialData = this.formatFields(this.props.initialData);
			if (window.location.hostname === 'localhost') {
				inputData.cep = _addressPerson.cep || '06126-320';
				inputData.address = _addressPerson.address || 'Rua Jaú';
				inputData.district = _addressPerson.district || 'Santo Antônio';
				inputData.number = _addressPerson.number || '51';
				inputData.complement = _addressPerson.complement || '';
				inputData.state = _addressPerson.state || 'SP';
				inputData.city = _addressPerson.city || 'Osasco';
			} else if(_addressPerson) {
				inputData.cep = _addressPerson.cep || '';
				inputData.address = _addressPerson.address || '';
				inputData.district = _addressPerson.district || '';
				inputData.number = _addressPerson.number || '';
				inputData.complement = _addressPerson.complement || '';
				inputData.state = _addressPerson.state || '';
				inputData.city = _addressPerson.city || '';
			} else {
				inputData.cep = initialData.cep || '';
				inputData.address = initialData.address || '';
				inputData.district = initialData.district || '';
				inputData.number = initialData.number || '';
				inputData.complement = initialData.complement || '';
				inputData.state = initialData.state || '';
				inputData.city = initialData.city || '';
			}

			this.setState({
				inputData
			});
			this.initialValues = inputData;
		}
	}

	formatFields(data) {
		for (var fieldName in data) {
			switch (fieldName) {
				case 'cep':
					data[fieldName] = data[fieldName].padStart(8, '0');
					data[fieldName] = data[fieldName].replace(
						/^([0-9]{5})([0-9]{3})$/i,
						'$1-$2'
					);
					break;
				default:
			}
		}

		return data;
	}

	getErrorMsg(name) {
		let errorMsgs = {
			cep: 'CEP inválido',
			address: 'Insira o endereço',
			district: 'Insira o bairro',
			number: 'Insira o número',
			state: 'Insira o estado',
			city: 'Insira a cidade'
		};

		return errorMsgs[name];
	}

	checkField(name, value) {
		let fieldChecked = false;
		let checkField = {
			cep: /^[0-9]{5}-[0-9]{3}$/i,
			address: /^([A-Za-z0-9çãàáâéêíóôõúÂÃÁÀÉÊÍÓÔÕÚÇ()"'!?$%:;,º°ª.-_-]+\s?){1,100}$/i,
			district: /^([^\d\s]+\s?){1,30}$/i,
			number: /^[0-9]{1,8}$/i,
			city: /^([^\d\s]+\s?){1,30}$/i,
			state: /^[A-Z]{2}$/
		};
		if (name === 'cep') {
			fieldChecked = checkField[name].test(this.state.inputData.cep);
		} else if (checkField[name]) {
			fieldChecked = checkField[name].test(value);
		} else {
			fieldChecked = true;
		}

		return fieldChecked;
	}

	async setCep(value, setFieldValue) {
		let cep = value.replace('-', '');
		await axios.get(`//viacep.com.br/ws/${cep}/json/`).then(response => {
			if (response.status === 200) {
				let addressData = response.data;
				let inputData = { ...this.state.inputData };

				if (response.data.erro) {
					setFieldValue('cep', cep);
					inputData.cep = addressData.cep;
				} else {
					inputData.cep = addressData.cep;
					inputData.address = addressData.logradouro;
					inputData.district = addressData.bairro;
					inputData.city = addressData.localidade;
					inputData.state = addressData.uf;

					setFieldValue('cep', inputData.cep);
					setFieldValue('address', inputData.address);
					setFieldValue('district', inputData.district);
					setFieldValue('city', inputData.city);
					setFieldValue('state', inputData.state);
				}

				this.setState(
					{
						inputData
					},
					() => {
						this.updateFields();
					}
				);
			}
		});
	}

	updateFields() {
		for (let fieldName in this.state.inputData) {
			let stateObj = {};
			let fieldValue = this.state.inputData[fieldName];
			if (this.checkField(fieldName, fieldValue)) {
				stateObj[fieldName] = {
					error: false,
					value: fieldValue
				};
			} else {
				stateObj[fieldName] = {
					error: true,
					msg: this.getErrorMsg(fieldName)
				};
			}
			this.setState(stateObj);
		}
		this.props.isCompleted();
	}

	setField(e, setFieldValue) {
		let value = e.target.value;
		let name = e.target.getAttribute('name');

		value = value.replace(/_$/g, '');

		if (name === 'cep' && value.length === 9) {
			this.setCep(value, setFieldValue);
		} else {
			let inputData = { ...this.state.inputData };

			inputData[name] = value;
			setFieldValue(name, inputData[name]);
			this.setState(
				{
					inputData
				},
				() => {
					this.props.isCompleted();
				}
			);
		}
	}

	getData() {
		let inputData = this.state.inputData;

		let dataSend = {};
		for (var fieldName in inputData) {
			if (this.checkField(fieldName, inputData[fieldName])) {
				dataSend[fieldName] = {
					error: false,
					value: inputData[fieldName]
				};
			} else {
				if (inputData[fieldName] === '') {
					dataSend[fieldName] = {
						error: true,
						msg: 'Campo vazio'
					};
				} else {
					dataSend[fieldName] = {
						error: true,
						msg: this.getErrorMsg(fieldName)
					};
				}
			}
		}

		return dataSend;
	}

	render() {
		const validationSchema = yup.object().shape({
			cep: yup
				.string('Insira o CEP')
				.required('Insira o CEP')
				.min(9, 'CEP inválido'),
			address: yup
				.string('Insira o endereço')
				.required('Insira o endereço')
				.min(1, 'Endereço inválido')
				.max(100, 'Endereço inválido'),
			district: yup
				.string('Insira o bairro')
				.required('Insira o bairro')
				.min(1, 'Bairro inválido')
				.max(30, 'Bairro inválido'),
			number: yup
				.number('Insira o número')
				.required('Insira o número')
				.min(1, 'Número inválido')
				.max(99999, 'Número inválido'),
			complement: yup.string(),
			city: yup
				.string('Insira a cidade')
				.required('Insira a cidade')
				.min(1, 'Cidade inválida')
				.max(30, 'Cidade inválida'),
			state: yup
				.string('Insira o estado')
				.required('Insira o estado')
				.min(2, 'Estado inválido')
		});

		const { loja } = this.props.match.params;

		let fieldError = '';
		if (this.props.error) {
			fieldError = (
				<div className='overlay'>
					<div className='overlay-box'>
						<div className='overlay-box--content'>
							<p>{this.props.error}</p>
						</div>
						<div className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-ok'
								onClick={this.props.errorAccept}>
								<FaThumbsUp size={18} color={'#0a53a6'} /> Ok
							</button>
						</div>
					</div>
				</div>
			);
		}

		this.props.onData(this.getData());

		const dependentIsActive = sessionStorage.getItem('dependentIsActive');

		return (
			<div className='form-step form-step-5'>
				{fieldError}

				<TitleSubscriber>
					{dependentIsActive == true ? (
						<h2>Endereço do Titular:</h2>
					) : (
						<h2>Endereço:</h2>
					)}
				</TitleSubscriber>
				{/* Formulário de endereço */}
				<Formik
					initialValues={this.initialValues}
					validationSchema={validationSchema}
					validateOnChange
					validateOnBlur
					validateOnMount
					enableReinitialize
					onSubmit={() => {}}>
					{({ values, errors, touched, setFieldValue, handleBlur }) => {
						return (
							<Form>
								<FormField className=' inputHeight'>
									<CustomInputMask
										id='cepcobranca'
										name='cep'
										mask='99999-999'
										maskChar=''
										onChange={e => {
											this.setField(e, setFieldValue);
										}}
										onBlur={handleBlur}
										value={values.cep}
										required
									/>
									<label
										htmlFor='cepcobranca'
										className={values.cep === '' ? 'subscriber' : ''}>
										<FaMapMarkerAlt size={10} className='icon' /> CEP
									</label>
									{(touched.cep || this.props.fieldsTouched) && errors.cep && (
										<div className='error-msg'>
											<FiAlertCircle size={13} />
											<small className='credit-card-error'>{errors.cep}</small>
										</div>
									)}
								</FormField>

								<FormField className='inputHeight'>
									<CustomInputMask
										id='logradourocobranca'
										name='address'
										onChange={e => {
											this.setField(e, setFieldValue);
										}}
										onBlur={handleBlur}
										value={values.address}
										required
									/>
									<label
										htmlFor='logradourocobranca'
										className={values.address === '' ? 'subscriber' : ''}>
										<FaRoad size={10} className='icon' /> Endereço
									</label>
									{(touched.address || this.props.fieldsTouched) &&
										errors.address && (
											<div className='error-msg'>
												<FiAlertCircle size={13} />
												<small className='credit-card-error'>
													{errors.address}
												</small>
											</div>
										)}
								</FormField>

								<div className='form-size'>
									<div className='form-size-1'>
										<FormField className=' inputHeight'>
											<CustomInputMask
												id='bairrocobranca'
												name='district'
												onChange={e => {
													this.setField(e, setFieldValue);
												}}
												onBlur={handleBlur}
												value={values.district}
												required
											/>
											<label
												htmlFor='bairrocobranca'
												className={values.district === '' ? 'subscriber' : ''}>
												<FaCity size={10} className='icon' /> Bairro
											</label>
											{(touched.district || this.props.fieldsTouched) &&
												errors.district && (
													<div className='error-msg'>
														<FiAlertCircle size={13} />
														<small className='credit-card-error'>
															{errors.district}
														</small>
													</div>
												)}
										</FormField>
									</div>
									<div className=' form-size-2'>
										<FormField className=' inputHeight'>
											<CustomInputMask
												id='numerocobranca'
												name='number'
												mask='99999'
												maskChar=''
												onChange={e => {
													this.setField(e, setFieldValue);
												}}
												onBlur={handleBlur}
												value={values.number}
												required
											/>
											<label
												htmlFor='numerocobranca'
												className={values.number === '' ? 'subscriber' : ''}>
												<FaHome size={10} className='icon' /> Número
											</label>
											{(touched.number || this.props.fieldsTouched) &&
												errors.number && (
													<div className='error-msg'>
														<FiAlertCircle size={13} />
														<small className='credit-card-error'>
															{errors.number}
														</small>
													</div>
												)}
										</FormField>
									</div>
									<div className='form-size-3'>
										<FormField className='inputHeight'>
											<CustomInputMask
												maxLength='20'
												id='complementocobranca'
												name='complement'
												onChange={e => {
													this.setField(e, setFieldValue);
												}}
												onBlur={handleBlur}
												value={values.complement}
												required
											/>
											<label
												htmlFor='complementocobranca'
												className={
													this.state.inputData.complement === ''
														? 'subscriber'
														: ''
												}>
												<FaBuilding size={10} className='icon' /> Complemento
											</label>
										</FormField>
									</div>
								</div>

								<div className='form-size'>
									<div className='form-size-1'>
										<FormField className='inputHeight'>
											<CustomInputMask
												id='city'
												name='city'
												onChange={e => {
													this.setField(e, setFieldValue);
												}}
												onBlur={handleBlur}
												value={values.city}
												required
											/>
											<label
												htmlFor='city'
												className={values.city === '' ? 'subscriber' : ''}>
												<FaCity size={10} className='icon' /> Cidade
											</label>
											{(touched.city || this.props.fieldsTouched) &&
												errors.city && (
													<div className='error-msg'>
														<FiAlertCircle size={13} />
														<small className='credit-card-error'>
															{errors.city}
														</small>
													</div>
												)}
										</FormField>
									</div>
									<div className='form-size-1'>
										<FormField className='select-new inputHeight'>
											<Field
												className='form-control'
												id='state'
												name='state'
												as='select'
												onChange={e => {
													this.setField(e, setFieldValue);
												}}
												onBlur={handleBlur}
												value={values.state}
												required>
												<option></option>
												<option value='AC' key='AC'>
													Acre
												</option>
												<option value='AL' key='AL'>
													Alagoas
												</option>
												<option value='AP' key='AP'>
													Amapá
												</option>
												<option value='AM' key='AM'>
													Amazonas
												</option>
												<option value='BA' key='BA'>
													Bahia
												</option>
												<option value='CE' key='CE'>
													Ceará
												</option>
												<option value='DF' key='DF'>
													Distrito Federal
												</option>
												<option value='ES' key='ES'>
													Espírito Santo
												</option>
												<option value='GO' key='GO'>
													Goiás
												</option>
												<option value='MA' key='MA'>
													Maranhão
												</option>
												<option value='MT' key='MT'>
													Mato Grosso
												</option>
												<option value='MS' key='MS'>
													Mato Grosso do Sul
												</option>
												<option value='MG' key='MG'>
													Minas Gerais
												</option>
												<option value='PA' key='PA'>
													Pará
												</option>
												<option value='PB' key='PB'>
													Paraíba
												</option>
												<option value='PR' key='PR'>
													Paraná
												</option>
												<option value='PE' key='PE'>
													Pernambuco
												</option>
												<option value='PI' key='PI'>
													Piauí
												</option>
												<option value='RJ' key='RJ'>
													Rio de Janeiro
												</option>
												<option value='RN' key='RN'>
													Rio Grande do Norte
												</option>
												<option value='RS' key='RS'>
													Rio Grande do Sul
												</option>
												<option value='RO' key='RO'>
													Rondônia
												</option>
												<option value='RR' key='RR'>
													Roraima
												</option>
												<option value='SC' key='SC'>
													Santa Catarina
												</option>
												<option value='SP' key='SP'>
													São Paulo
												</option>
												<option value='SE' key='SE'>
													Sergipe
												</option>
												<option value='TO' key='TO'>
													Tocantins
												</option>
											</Field>
											<label
												htmlFor='state'
												className={values.state === '' ? 'subscriber' : ''}>
												<FaCity size={10} className='icon' /> Estado
											</label>
											{(touched.state || this.props.fieldsTouched) &&
												errors.state && (
													<div className='error-msg'>
														<FiAlertCircle size={13} />
														<small className='credit-card-error'>
															{errors.state}
														</small>
													</div>
												)}
										</FormField>
									</div>
								</div>
							</Form>
						);
					}}
				</Formik>
				{/* # Formulário de endereço */}
			</div>
		);
	}
}

export default FormAddress;

export function CustomInputMask(props) {
	const [field] = useField({
		name: props.name,
		type: 'text',
		id: props.id,
		mask: props.mask,
		maskChar: props.maskChar
	});
	return (
		<InputMask
			{...props}
			{...field}
			className='form-control'
			onChange={props.onChange}
			value={props.value}
		/>
	);
}
